import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ScanFileIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="13 14 17 16"
    >
      <g fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
        <path d="M14.6,17.4v-2.1c0-.2.2-.4.4-.4h2.2" />
        <path d="M17.1,29h-2.1c-.2,0-.4-.2-.4-.4v-2.2" />
        <path d="M26.9,15h2.1c.2,0,.4.2.4.4v2.2" />
        <path d="M29.4,26.5v2.2c0,.2-.2.4-.4.4h-2.2" />
        <path d="M26,20c0,0,0,.1,0,.1h-2.6c0,0,0,0,0-.1v-2.6" />
        <path d="M26.1,20v6.4c0,.2-.2.4-.4.4h-7.4c-.2,0-.4-.1-.4-.4v-8.8c0-.2.2-.4.4-.4h4.9l2.9,2.8Z" />
      </g>
    </svg>
  </CircledIcon>
);
